import { colors } from "@ui/Theme";

export const DEFAULT_COLORS = [
  "#1F77B4",
  "#D62728",
  "#2CA02C",
  "#FF7F0E",
  "#9467BD",
  "#17BECF",
  "#E377C2",
  "#7F7F7F",
  "#8C564B",
  "#BCBD22",
] as const;

export const SEQUENTIAL_COLORS = {
  start: { r: 136, g: 217, b: 16 },
  end: { r: 0, g: 21, b: 90 },
};

export const getDefaultColor = (index: number) => DEFAULT_COLORS[index % DEFAULT_COLORS.length];

export const getDefaultSequentialColor = (t: number) => {
  const w = t * 2 - 1;
  const w1 = (w + 1) * 0.5;
  const w2 = 1 - w1;
  const rgb = [
    SEQUENTIAL_COLORS.start.r * w1 + SEQUENTIAL_COLORS.end.r * w2,
    SEQUENTIAL_COLORS.start.g * w1 + SEQUENTIAL_COLORS.end.g * w2,
    SEQUENTIAL_COLORS.start.b * w1 + SEQUENTIAL_COLORS.end.b * w2,
  ];
  return `rgb(${rgb.join(",")})`;
};

export const enableValidityMarker = (mark: string, validity: string) => {
  switch (validity) {
    case "INVALID_AUTO":
    case "INVALID_MANUAL":
    case "INVALID_INHERITED":
    case "INVALID_AUTO_CROSS_FILTER":
    case "VALID_MANUAL":
    case "VALID_PARTIAL_INPUTS":
      return true;
    case "VALID_AUTO":
      return mark !== "line";
    default:
      return false;
  }
};

export const getValidityColor = (validity: string) => {
  switch (validity) {
    case "INVALID_AUTO":
    case "INVALID_MANUAL":
    case "INVALID_INHERITED":
    case "INVALID_AUTO_CROSS_FILTER":
      return colors.raw.oxygen400;
    default:
      return;
  }
};

export const getValidityShape = (validity: string) => {
  switch (validity) {
    case "VALID_MANUAL":
    case "INVALID_MANUAL":
      return "diamond";
    default:
      return "circle";
  }
};

export const getFaultStatusColor = (faultStatus: string) => {
  switch (faultStatus) {
    case "TO_BE_ANALYSED":
      return colors.phosphorus400;
    case "SUSPECTED":
      return colors.oxygen400;
    case "CONFIRMED":
    case "REJECTED":
    case "LEGACY_REJECTED":
      return;
    default:
      return;
  }
};

export const getFaultStatusShape = (faultStatus: string) => {
  switch (faultStatus) {
    default:
      return "circle";
  }
};
